import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import { PROJECTS } from "../../Constants";

function Projects() {
  return (
    <Container fluid id="projects" className="project-section">
      <Container>
        <h1 className="project-heading">
          Products I&apos;ve <strong className="purple">Shipped</strong>
        </h1>
        <p className="project-intro">
          Real client work—mobile apps, websites, and full-stack platforms.
          Each project shows what was built and where you can see it live.
        </p>
        <Row className="project-grid">
          {PROJECTS.map((project, index) => (
            <Col lg={4} md={6} xs={12} className="project-card" key={index}>
              <ProjectCard
                imgPath={project.image}
                technologyUsed={project.technologyUsed}
                deliverables={project.deliverables}
                isBlog={false}
                title={project.name}
                description={project.description}
                links={project.links}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
